import { LoggingProvider } from "../../../schema/types/org/input";

export function getNameOfProvider(provider: LoggingProvider) {
  switch (provider) {
    case "cloudWatch":
      return "CloudWatch";
    case "coralogix":
      return "Coralogix";
    case "datadog":
      return "Datadog";
    case "elastic":
      return "Elastic";
    case "fluentd":
      return "Fluentd";
    case "logzio":
      return "logz.io";
    case "opentelemetry":
      return "OpenTelemetry";
    case "s3":
      return "S3";
    case "stackdriver":
      return "Stackdriver";
    case "syslog":
      return "Syslog";
  }
}
